import { f7 } from 'framework7-react';
import { useMemo } from 'react';
import { ProgressItemType } from '../../../types/bodyAndPaint';
import { useProcessImageData } from './hook/useProcessImageData';
import { useStorageItem } from './hook/useStorageItem';
import { RepairProcessImage } from './repairProcessImage/repairProcessImage';
import './repairProcessImage/repairProcessImage.css';
import { PageTemplateComponent } from './util/common/pageTemplate/pageTemplate';
import { paths } from '@/config/paths';

export const RepairProcessImagePage = () => {
  const { stored } = useStorageItem<{
    label: string;
    checkInImage: string[];
    item: ProgressItemType[];
  }>({ key: 'repairProcessImage' });

  const checkInImage = useMemo(() => stored?.checkInImage ?? [], [stored]);
  const processLabel = useMemo(() => stored?.label ?? '', [stored]);
  const processItem = useMemo(
    () => stored?.item ?? ([] as ProgressItemType[]),
    [stored],
  );
  const handleClickBack = () => {
    f7.views.main.router.navigate(paths.bpsRepairImageCheck);
  };
  const { processImageDataList } = useProcessImageData({ info: processItem });

  return (
    <PageTemplateComponent
      pageName={'repairProcessImageCheck'}
      title={'作業の工程'}
      onBack={handleClickBack}
    >
      <RepairProcessImage
        info={processImageDataList}
        checkInImage={checkInImage}
        label={processLabel}
      />
    </PageTemplateComponent>
  );
};
